import React from 'react';
import { Box } from '@mui/material';
import CopyButton from './CopyButton';

/**
 * Monospace text on a tinted block, with a copy button pinned to its top-right corner. The right
 * padding keeps the text clear of the button however many lines it runs to.
 */
const CodeBlock = function CodeBlock({ copyText = '', sx = {}, children }) {
  return (
    <Box
      sx={{
        position: 'relative',
        minWidth: 0,
        p: 1,
        pr: 5,
        borderRadius: 1,
        bgcolor: 'action.hover',
        fontFamily: 'monospace',
        fontSize: '0.85rem',
        overflowWrap: 'anywhere',
        ...sx,
      }}
    >
      {children}
      <Box sx={{ position: 'absolute', top: 2, right: 2 }}>
        <CopyButton text={copyText} />
      </Box>
    </Box>
  );
};

export default CodeBlock;
